/* Badan Studios — Página «Juegos»: filtro por tipo de juego.
   - Sin JS se ven todos los juegos y el filtro sigue oculto (atributo hidden).
   - Cada botón lleva data-filter con la categoría en formato handle («all» = todos).
   - Tarjetas y columnas de la tabla llevan data-categories con sus categorías separadas por espacios.
   - Anuncia cuántos juegos quedan en una región aria-live. */
(function () {
  'use strict';

  document.querySelectorAll('[data-games-explorer]').forEach(function (root) {
    var filters = root.querySelector('[data-games-filters]');
    if (!filters) return;

    var buttons = filters.querySelectorAll('[data-filter]');
    var items = root.querySelectorAll('[data-categories]');
    var cards = root.querySelectorAll('li[data-categories]');
    var status = root.querySelector('[data-games-status]');

    function matches(el, filter) {
      if (filter === 'all') return true;
      var list = ' ' + (el.getAttribute('data-categories') || '') + ' ';
      return list.indexOf(' ' + filter + ' ') !== -1;
    }

    function apply(filter, announce) {
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-filter') === filter));
      });

      items.forEach(function (el) {
        el.hidden = !matches(el, filter);
      });

      var visible = 0;
      cards.forEach(function (card) {
        if (!card.hidden) {
          visible += 1;
          // Si la tarjeta estaba oculta cuando pasó por pantalla, la animación de entrada no llegó a lanzarse
          card.classList.add('is-visible');
        }
      });

      if (announce && status) {
        var label = status.getAttribute(visible === 1 ? 'data-label-one' : 'data-label-other') || '[n]';
        status.textContent = label.replace('[n]', visible);
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.getAttribute('data-filter'), true);
      });
    });

    filters.hidden = false;
  });
})();
